export default {
    maxUploadSize: 10000000, // Maximum upload file size in Bytes
    maxUploadSizeLabel: "10 Mb",
};
